import generalSection from "../_section/section.class";
import { adminProofOfDepositInBank, userProofOfDepositInBank} from "./upload";
import DataForm from "./DataForm";
import {balanceOfFundsFunds} from "../../../../../components/client/application-stages/_common/funding/BalanceOfFunds";
import problem from "../_section/section-problem.class";

export class userProofOfDepositInBankSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userProofOfDepositInBank);
        // Add missing date error

    }
}

export class adminProofOfDepositInBankSection extends userProofOfDepositInBankSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminProofOfDepositInBank);
        this.useStatementAlignmentDateToExpire = false
        this.DataForm = DataForm
        this.sortByDateProp('documentDate');
        this.activeUpload = this.uploads.find(u=> u.allValuesAnswered && u.isVerifiable)
        this.setProblems(this.getProblems())

    }
    getProblems (){
        const problems =  this.problemsList.universalUploadProblems() ?? [];
        return  problems
    }

    getSectionSummary = ()=>{
        const balancesInTheseUploads = this.verifiableUploads.filter(it=>it.documentDate && it.values.closingBalance).map(it=>it.values.closingBalance)
        const totalBalance = balancesInTheseUploads.reduce((acc, curr) => acc + curr, 0)

        const oldestUpload = this.verifiableUploads.filter(it=>it.documentDate).sort((a, b) => a.documentDate - b.documentDate)[0]
        return [
            {
                name: this.personalTitle,
                tags: [{
                    name: 'Total Balance',
                    value: totalBalance
                },{
                    name: 'Oldest Upload',
                    value: oldestUpload?.documentDate?.format('DD/MM/YYYY') || 'N/A'
                }]
            }
        ]
    }
}